import { Modal, ModalProps } from "antd";
import React from "react";
import styles from "./bless-modal.module.scss";

interface Props extends ModalProps {
  children: React.ReactNode;
}

const BlessModal = ({ children, ...modalProps }: Props) => {
  return (
    <Modal
      footer={null}
      centered
      className={styles.modalContainer}
      classNames={{
        content: styles.modalContent,
        wrapper: styles.wrapper,
      }}
      {...modalProps}>
      {children}
    </Modal>
  );
};

export default BlessModal;
